import axios from "./httpClient";
import { ApiType } from "./Types";
import { getUrl } from "./getURL";
import { ErrorMessages } from "../constants";
import { throwApiError } from "./apiError";
import { getTerminalId } from "../helpers";
import { getTrackingHeadersMap } from "./getTrackingHeaders";

export interface IClearExceptionRequest {
  osdNumber: number;
  openPieces: number;
  piecesCleared: number;
  clearingCode: string;
  proNumber?: number;
  comments?: string;
  moduleName?: string; // dashboard/myassignment/overages/shortages/damagesOrRefusals/onHand/misdelivery
}

export interface IClearExceptionResponse {
  success: boolean;
  message?: string;
  data?: any;
}

/**
 * API call to clear an exception
 * POST /api/v1/exception/clear
 * @param params - Clear exception request parameters
 * @returns - Response from the clear exception API
 */
export const clearExceptionAPI = async (
  params: IClearExceptionRequest
): Promise<IClearExceptionResponse> => {
  try {
    const url = getUrl(ApiType.EXCEPTION_CLEAR);
    const staticHeaders = getTrackingHeadersMap(ApiType.EXCEPTION_CLEAR);
    const headers = {
      ...staticHeaders,
      "OSD-Reporting-Terminal": getTerminalId(),
      "OSD-Exception-Number": params.osdNumber.toString(),
      "OSD-Module-Name": params.moduleName,
    };
    delete params.moduleName;
    const response = await axios.post(url, params, { headers });
    return response.data;
  } catch (error: any) {
    throwApiError(error, ErrorMessages.clearExceptionError);
    throw error;
  }
};
